import { Header } from "../../common/Header";
import { useEffect, useState } from "react";
import { useConfig } from "@nusrif/contexts";

export const TermsAndConditionsPage = () => {
  const TermsAndConditionsURL = "https://cms.twoandfive.in/terms-and-conditions?context=app";
  const config = useConfig();
  const effectiveUrl = (config?.termsAndConditionsUrl && config.termsAndConditionsUrl.trim().length > 0)
    ? config.termsAndConditionsUrl
    : TermsAndConditionsURL;
  const [isLoaded, setIsLoaded] = useState(false);
  const [failedToLoad, setFailedToLoad] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!isLoaded) {
        setFailedToLoad(true);
      }
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [isLoaded]);

  return (
    <div className="min-h-screen w-full bg-gray-50">
      {/* Header */}
      <Header 
        title="Terms and Conditions" 
        showBackButton={true} 
        showCartButton={false}
      />
      
      {/* Main Content */}
      <div className="pt-20 px-5 pb-5">
        <div className="bg-white rounded-lg border border-gray-100 shadow-sm overflow-hidden">
          <iframe
            title="Privacy Policy"
            src={effectiveUrl}
            className="w-full h-[calc(100vh-140px)]"
            onLoad={() => setIsLoaded(true)}
          />
        </div>

        {failedToLoad && (
          <div className="mt-4 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <p className="text-yellow-800">
              We couldn't display the privacy policy within the app. You can open it directly here:
              {" "}
              <a
                href={effectiveUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-blue underline"
              >
                {effectiveUrl}
              </a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};